import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=template&id=b8806326&scoped=true&"
import script from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=script&lang=js&"
export * from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmployeeRegistrationDialogStep5.vue?vue&type=style&index=0&id=b8806326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8806326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VFadeTransition})
